const e = "TV", o = "MCHANNEL", c = "CATCHUP", r = "TRAILER", i = "LIVE", v = "OTHER", d = /* @__PURE__ */ new Map([
  ["tv", e],
  ["tv_dvr", e],
  ["tv_dvr_vod", e],
  ["tv_linear", e],
  ["tv_linear_vod", e],
  ["vod", "VOD"],
  ["m_ch", o],
  ["m_ch_vod", o],
  ["tv_dvr_catchup", c],
  ["trailer", r],
  ["live", i]
]);
function a(t) {
  return d.get(t) || v;
}
function T(t) {
  var _;
  const n = {
    object_type: a(t.content_type),
    object_id: Number(t.object_id),
    object_title: (_ = t.title) != null ? _ : ""
  };
  return t.channel_id && (n.virtual_object_id = t.video_id), n;
}
export {
  T as createTarget,
  a as generalizeContentType
};
